import React, { useState } from "react";
import Header from "../../component/Header";
import BlacklistUser from "../../component/BlacklistUser";
import FooterComponent from "../../component/Footer";
import BlacklistComponent from "../../component/BlacklistComponent copy";
import { FaIndustry} from "react-icons/fa";
import Background from "../../assets/Images/blacklisted.jpg";
import { blacklistedCompanies, blacklistedUsers } from "../../assets/data";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { BLACKLIST_API } from "../../resources/resource";
import { useFetchData } from "../../hooks/useFtechData";

function Blacklist() {
  const [formData, setFormData] = useState({});
  const [companyList, setCompanyList] = useState(blacklistedCompanies);
  const [userList, setUsersList] = useState(blacklistedUsers);
  const [selectionError, setSelectionError] = useState(false);

  const makeRequest = useMakeRequest();
  const { data, loading } = useFetchData(BLACKLIST_API);

  const handleSubmit = (e) => {
    e.preventDefault();
    const searchTable = formData.searchOption;
    if (!searchTable) {
      return setSelectionError(true);
    }
    const nameToSearch = formData.blacklistName.toLowerCase();
    if (searchTable === "companies") {
      setCompanyList(
        blacklistedCompanies.filter((company) =>
          company.companyName.toLowerCase().includes(nameToSearch)
        )
      );
      return;
    }
    setUsersList(
      blacklistedUsers.filter((user) =>
        user.Fullname.toLowerCase().includes(nameToSearch)
      )
    );
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setCompanyList(blacklistedCompanies);
    setUsersList(blacklistedUsers);
    setSelectionError(false);
  };

  return (
    <div className="text-sm pt-16 sm:pt-20 px-10">
      <Header />
      <div className="mx-auto my-10 p-4 max-w-screen-xl">
        {/* Hero Section */}
        <div
          style={{ backgroundImage: `url(${Background})` }}
          className="flex flex-col items-center justify-center gap-6 p-8 rounded-lg bg-cover bg-center relative text-white shadow-md"
        >
          <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div>
          <div className="relative z-10 text-center">
            <h1 className="text-3xl font-semibold mb-4">Blacklist</h1>
            <p className="max-w-2xl mx-auto text-gray-200">
              At eJobs, we blacklist suspicious companies/users. When a
              company/user is added to the blacklist, it means that our safety
              and verification agents have marked them as not safe, trustworthy,
              or charged with fraudulent activities. There are several reasons
              why you can be flagged on our blacklist.
            </p>
          </div>
          {/* Search Form */}
          <form
            onSubmit={handleSubmit}
            className="relative z-10 w-full max-w-2xl"
          >
            <div className="flex flex-col gap-4 mb-6">
              <div className="relative">
                <select
                  name="searchOption"
                  onChange={handleChange}
                  className="w-full p-3 pl-10 text-gray-700 bg-white border border-gray-300 rounded-lg appearance-none focus:outline-none focus:border-blue-500"
                >
                  <option value="">Select type</option>
                  <option value="companies">Companies</option>
                  <option value="users">Users</option>
                </select>
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <FaIndustry className="text-gray-500" />
                </div>
              </div>
              <div className="w-full flex items-center justify-center">
                <input
                  className="outline-none w-full text-gray-700"
                  type="text"
                  name="blacklistName"
                  placeholder="Enter name to search"
                  onChange={handleChange}
                />
                <button
                  type="submit"
                  className="bg-green-500 text-white px-4 py-[0.7rem] h-full"
                >
                  Search
                </button>
              </div>
            </div>
            {selectionError && (
              <span className="block mt-2 text-red-500">
                Error: Please select a type
              </span>
            )}
          </form>
        </div>

        {/* Blacklisted Companies and Users */}
        <div className="mt-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                Blacklisted Companies
              </h2>
              {companyList.map((company, index) => (
                <BlacklistComponent
                  key={index}
                  companyName={company.companyName}
                  companyAddress={company.companyAddress}
                  complaint={company.reports}
                />
              ))}
            </div>
            <div>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                Blacklisted Users
              </h2>
              {userList.map((user, index) => (
                <BlacklistUser
                  key={index}
                  complaint={user.reports}
                  username={user.Fullname}
                  email={user.email}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <FooterComponent />
    </div>
  );
}

export default Blacklist;
